import React, { useEffect } from 'react';
import { X, AlertCircle, HelpCircle } from 'lucide-react';
import './CustomModal.css';

const CustomModal = ({ 
    isOpen, 
    title, 
    message, 
    confirmText = 'OK', 
    cancelText = 'Cancel', 
    onConfirm, 
    onCancel, 
    type = 'confirm' 
}) => {
    // Prevent scrolling when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay fade-in" onClick={onCancel}>
            <div className="custom-modal-container slide-up" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="modal-header-content">
                        {type === 'confirm' ? (
                            <HelpCircle className="modal-icon confirm-icon" size={24} />
                        ) : (
                            <AlertCircle className="modal-icon alert-icon" size={24} />
                        )}
                        <h3>{title}</h3>
                    </div>
                    <button className="close-modal-btn" onClick={onCancel}>
                        <X size={20} />
                    </button>
                </div>
                
                <div className="modal-body">
                    <p>{message}</p>
                </div>

                <div className="modal-footer">
                    {type === 'confirm' && (
                        <button className="btn-secondary" onClick={onCancel}>
                            {cancelText}
                        </button>
                    )}
                    <button className="btn-primary" onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomModal;
